// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"abb6aa7b","400":"58876918","453":"1b275599","455":"6842cd56"}[chunkId] + ".chunk.js";
};